import { asText } from "@prismicio/helpers";
import type { HTMLComponent } from "@commercekit/react";
import { Disclosure } from "@headlessui/react";
import { FaqSliceSliceDefault } from "prismicio-types";
import HelpCircleIcon from "~/components/icons/HelpCircleIcon";

const DefaultFaq: HTMLComponent<{
  slice: FaqSliceSliceDefault;
}> = ({ slice }) => {

  return (
    <div className="col-sm-6 pr-xl-5 faq faq-section">
      <div className="panel-group">
        <div className="panel panel-default panel-header">
          <div className="panel-heading">
            <h2 className="panel-title">{asText(slice.primary.title)}</h2>
          </div>
        </div>
        {slice.items.map((item) => (
          <div key={asText(item.question)} className="panel panel-default">
            <Disclosure as="div" defaultOpen={false}>
              {({ open }) => (
                <>
                  <Disclosure.Button as="div" className="panel-heading">
                    <h3 className="panel-title">
                      <a>
                        <span className="hexa d-inline-flex align-items-center justify-content-center">
                          <HelpCircleIcon />
                        </span>
                        <span>{asText(item.question)}</span>
                        {/* plus (closed) ⇄ minus (open) — cross-faded in custom.css */}
                        <i className={`arrow${open ? " open" : ""}`}></i>
                      </a>
                    </h3>
                  </Disclosure.Button>

                  <Disclosure.Panel
                    as="div"
                    className="panel-collapse collapse show"
                  >
                    <div className="panel-body">
                      <span
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: asText(item.answer) || "",
                        }}
                      ></span>
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultFaq;
